import { Loading } from '@components/common';
import { usageMetricList ,
  apiAccountsDetailsAtom,
  intervalAtom,
  granularityAtom,
} from '@src/components/usage-dashboard/atoms';
import { useFetchAPIUsageMetric } from '@src/components/usage-dashboard/hooks/dataFetcherhooks';
import { useMakeExportData } from '@src/components/usage-dashboard/hooks/useMetricSeries';
import UsageMetricCard from '@src/components/usage-dashboard/MetricsPanel/UsageMetricCard/UsageMetricCard';
import { Button, Col, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useSelector } from 'react-redux';
import { showApiUsageBreakdownFeatureSelector } from '@store/common/selectors';
import '../metricpanel.css';

const ApiMetricsPanel = () => {
  const { data: seriesData, isFetching }: any = useFetchAPIUsageMetric({
    enabled: true,
    product: 'API',
  });
  useMakeExportData({
    seriesData,
    sectionKey: 'ud-api-metric-timeseries',
    title: 'API Usage Metrics',
  });
  const metricList = Object.keys(usageMetricList).filter(
    (key) => usageMetricList[key].product === 'API',
  );
  const showBreakdown = useSelector(showApiUsageBreakdownFeatureSelector);

  const interval = useAtomValue(intervalAtom);
  const granularity = useAtomValue(granularityAtom);
  const apiAccounts = useAtomValue(apiAccountsDetailsAtom);

  const openBreakdown = () => {
    window.dispatchEvent(
      new CustomEvent('open-api-usage-breakdown', {
        detail: { interval, granularity, apiAccounts },
      }),
    );
  };

  if (isFetching) {
    return <Loading></Loading>;
  }
  return (
    <div>
      <Title level={5} className="titleStyle">
        API Usage{' '}
        {showBreakdown && (
          <Button type="link" size="small" onClick={openBreakdown}>
            More Info
          </Button>
        )}
      </Title>
      <Row gutter={{ xs: 4, md: 8, lg: 12 }} className="rowStyle">
        {metricList.map((metric) => (
          <Col key={metric} xs={24} md={12} lg={12} className="colStyle">
            <UsageMetricCard metric={metric}></UsageMetricCard>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ApiMetricsPanel;
